// Polyfill for util module in browser

function inherits(ctor, superCtor) {
  if (superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true,
      },
    });
  }
}

function debuglog(section) {
  return function () {
    // No-op in browser
    if (
      typeof process !== "undefined" &&
      process.env &&
      process.env.NODE_ENV === "development"
    ) {
      console.log.apply(console, arguments);
    }
  };
}

function deprecate(fn, msg) {
  return function () {
    console.warn(msg);
    return fn.apply(this, arguments);
  };
}

function format(f) {
  let i = 1;
  const args = arguments;
  let str = String(f).replace(/%[sdj%]/g, function (x) {
    if (x === "%%") return "%";
    if (i >= args.length) return x;
    switch (x) {
      case "%s":
        return String(args[i++]);
      case "%d":
        return Number(args[i++]);
      case "%j":
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return "[Circular]";
        }
      default:
        return x;
    }
  });
  for (let x = args[i]; i < args.length; x = args[++i]) {
    if (x === null || typeof x !== "object") {
      str += " " + x;
    } else {
      str += " " + JSON.stringify(x);
    }
  }
  return str;
}

function inspect(obj, opts) {
  try {
    return JSON.stringify(obj, null, 2);
  } catch (e) {
    return String(obj);
  }
}

function isArray(arg) {
  return Array.isArray(arg);
}

function isBoolean(arg) {
  return typeof arg === "boolean";
}

function isNull(arg) {
  return arg === null;
}

function isNullOrUndefined(arg) {
  return arg == null;
}

function isNumber(arg) {
  return typeof arg === "number";
}

function isString(arg) {
  return typeof arg === "string";
}

function isSymbol(arg) {
  return typeof arg === "symbol";
}

function isUndefined(arg) {
  return arg === void 0;
}

function isRegExp(re) {
  return Object.prototype.toString.call(re) === "[object RegExp]";
}

function isObject(arg) {
  return typeof arg === "object" && arg !== null;
}

function isDate(d) {
  return Object.prototype.toString.call(d) === "[object Date]";
}

function isError(e) {
  return (
    Object.prototype.toString.call(e) === "[object Error]" || e instanceof Error
  );
}

function isFunction(arg) {
  return typeof arg === "function";
}

function isPrimitive(arg) {
  return (
    arg === null ||
    typeof arg === "boolean" ||
    typeof arg === "number" ||
    typeof arg === "string" ||
    typeof arg === "symbol" ||
    typeof arg === "undefined"
  );
}

function log() {
  console.log.apply(console, arguments);
}

function promisify(original) {
  return function () {
    const args = Array.prototype.slice.call(arguments);
    return new Promise((resolve, reject) => {
      args.push((err, value) => {
        if (err) {
          reject(err);
        } else {
          resolve(value);
        }
      });
      original.apply(this, args);
    });
  };
}

// Create util object with all functions
const util = {
  inherits,
  debuglog,
  deprecate,
  format,
  inspect,
  isArray,
  isBoolean,
  isNull,
  isNullOrUndefined,
  isNumber,
  isString,
  isSymbol,
  isUndefined,
  isRegExp,
  isObject,
  isDate,
  isError,
  isFunction,
  isPrimitive,
  log,
  promisify,
};

// Also attach functions as properties for CommonJS compatibility
util.inherits = inherits;
util.debuglog = debuglog;
util.deprecate = deprecate;
util.format = format;
util.inspect = inspect;
util.isArray = isArray;
util.isBoolean = isBoolean;
util.isNull = isNull;
util.isNullOrUndefined = isNullOrUndefined;
util.isNumber = isNumber;
util.isString = isString;
util.isSymbol = isSymbol;
util.isUndefined = isUndefined;
util.isRegExp = isRegExp;
util.isObject = isObject;
util.isDate = isDate;
util.isError = isError;
util.isFunction = isFunction;
util.isPrimitive = isPrimitive;
util.log = log;
util.promisify = promisify;

// Export for ES modules
export {
  inherits,
  debuglog,
  deprecate,
  format,
  inspect,
  isArray,
  isBoolean,
  isNull,
  isNullOrUndefined,
  isNumber,
  isString,
  isSymbol,
  isUndefined,
  isRegExp,
  isObject,
  isDate,
  isError,
  isFunction,
  isPrimitive,
  log,
  promisify,
};

// Default export for CommonJS compatibility
export default util;
